module.exports = __webpack_public_path__ + "img/Image -3.af2705ac.png";